import { Outlet, type RouteObject, redirect } from 'react-router';

import ProtectedRoute from 'src/components/ProtectedRoute/ProtectedRoute';
import InvitePage from 'src/pages/Onboarding/Invite';
import OrganizationPage from 'src/pages/Onboarding/Organization';

export const onboardingRoutes: RouteObject = {
  element: (
    <ProtectedRoute>
      <Outlet />
    </ProtectedRoute>
  ),
  path: 'onboarding/*',
  loader: ({ params }) => {
    const { '*': splat = '' } = params;

    if (!splat) return redirect('/onboarding/organization');

    return null;
  },
  children: [
    {
      path: 'organization',
      element: <OrganizationPage />,
    },
    {
      path: 'invite',
      element: <InvitePage />,
    },
  ],
};
